import { call, put, takeLeading } from 'redux-saga/effects'

import getExternalCourse from 'api/administration/externalCourses/Get'
import { onHttpError } from 'helpers/access.helper'
import { ActionWithPayload } from 'helpers/redux-actions.helper'
import {
  GET_ADMIN_EXTERNAL_COURSE,
  PayloadGetExternalCourse,
  Actions,
} from '../../actions/externalCourses.action'

async function handleGetExternalCourse(
  externalCourseId: PayloadGetExternalCourse['id']
) {
  return getExternalCourse(externalCourseId)
}

const pattern = GET_ADMIN_EXTERNAL_COURSE

export type GetExternalCourseAction = ActionWithPayload<
  typeof pattern,
  PayloadGetExternalCourse
>

function* getExternalCourseEffectSaga(action: GetExternalCourseAction) {
  try {
    const { id } = action.payload
    yield put(Actions.getExternalCourseLoading(true))
    const data = yield call(handleGetExternalCourse, id)
    yield put(Actions.getExternalCourseSuccess(data))
  } catch (error) {
    onHttpError(error)
    console.log('error: ', error)
  }
  yield put(Actions.getExternalCourseLoading(false))
}

export function* getAdminExternalCourseWatcherSaga() {
  yield takeLeading(pattern, getExternalCourseEffectSaga)
}
